import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import { adminGetAllCenters } from 'services/center';
import { adminGetAllScanners,	
	adminGetScannerById,
	adminPatchScanner,
	adminDeleteScanner,
	resetFocusScanner,
	adminPostScanner,
	initNewScanner}
	from 'services/scanner';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/Scanners/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	name: Yup.string().required('Champ requis'),
});

class ScannersAdmin extends Component {

	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusScanner();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllCenters();
		this.props.adminGetAllScanners();
	};

	focusOnElement = (elt) => {
		this.props.adminGetScannerById(elt.id);
	};

	onAddClick = () => {
		this.props.initNewScanner();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostScanner(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchScanner(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteScanner(
			this.props.scanners.focus.data.id
		);
	};

	render() {
		const { scanners, centers } = this.props;
		const { focus, list } = scanners;
		const scanner = focus.data;
		const newScanner =
			scanner !== null && scanner.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={{data: scanners.list.data.map(i => {return {...i, center: i.center ? i.center.name : 'AUCUN CENTRE'}})}}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="Scanners"
					addButtonText="Nouveau scanner"
					onAddButtonClick={this.onAddClick}
					defaultLabel={e => e.name}
					groupField='center'
					focusedEltId={scanner}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity="Scanners"
					icon='info'
					//importFunction={this.props.adminImportCenters}
				>
					{scanner !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: scanner.id,
								name: scanner.name ||'',
								abbreviation: scanner.abbreviation || '',
								center: scanner.center?.id || null,
								reassign: false
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors, values }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusScanner}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={ 
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newScanner ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newScanner && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm errors={errors} centers={centers.list.data} values={values} />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		scanners: state.admin.scanners,
		centers: state.admin.centers,
	};
};

const mapDispatchToProps = {
	adminGetAllScanners,
	adminGetScannerById,
	adminPatchScanner,
	adminDeleteScanner,
	resetFocusScanner,
	adminPostScanner,
	initNewScanner,
	adminGetAllCenters,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ScannersAdmin);
